import React, { useEffect, useState } from 'react';
import StatusFilterOption, { FilterBy } from '../models/StatusFilterOption';

import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import ProgressStatusCode from '../models/ProgressStatusCode';
import Select from '@mui/material/Select';

interface StatusPickerProps {
  options: StatusFilterOption[];
  onChange: (values: ProgressStatusCode[]) => void;
}

const StatusPicker = (props: StatusPickerProps) => {
  const [filters, setFilters] = useState<FilterBy[]>([]);

  useEffect(() => {
    props.onChange(toFilters(filters));
  }, [filters]);

  const toFilters = (selectedStatus: FilterBy[]) => {
    const selectedFilters = [] as ProgressStatusCode[];
    for (let status of selectedStatus) {
      const filters = props.options.filter((o) => o.label === status)[0].values;
      selectedFilters.push(...filters);
    }

    return selectedFilters;
  };

  const onFilterChange = (event: any) => {
    setFilters(event.target.value);
  };

  return (
    <FormControl variant="outlined" margin="dense" size="small">
      <InputLabel id="mutiple-chip-label">Filter by</InputLabel>
      <Select
        multiple
        label="Filter by"
        value={filters}
        MenuProps={{
          variant: 'menu'
          // getContentAnchorEl: null
        }}
        onChange={onFilterChange}
        style={{
          width: '250px'
        }}
        renderValue={(selected) => (
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap'
            }}
          >
            {(selected as string[]).map((value) => (
              <Chip
                key={value}
                label={value}
                style={{ margin: 2 }}
                size="small"
              />
            ))}
          </div>
        )}
      >
        {props.options.map((s) => (
          <MenuItem key={s.label} value={s.label}>
            <Checkbox checked={filters.includes(s.label)} />
            <ListItemText primary={s.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StatusPicker;
